import { TooltipLabel, renderLabel } from './TooltipLabel';

export { TooltipLabel, renderLabel };